import {
  BgImage,
  KitchenCompare,
  PriceGroupMeter,
} from "@prmf/site-components";
import { Kitchen } from "@prmf/site-data";
import { routes, t } from "@prmf/site-router";
import { NavLink, useLoaderData } from "@remix-run/react";
import { twJoin } from "tailwind-merge";

export function List({ kitchens }: { kitchens: Kitchen[] }) {
  return kitchens.map((k) => {
    return (
      <NavLink to={k.slug} key={k.slug}>
        <BgImage
          className="h-64 rounded-sm bg-zinc-100 md:h-72"
          src={`/media/${k.slug}/_hero-01.jpg`}
        />
        <div className="mt-4">
          <div className="mb-2">
            <h3 className="text-sm font-semibold">{k.name}</h3>
            {k.priceGroup ? (
              <div className="flex justify-between">
                <h4 className="text-xs text-neutral-400">
                  Price group {k.priceGroup}
                </h4>
                <PriceGroupMeter color={k.accentColor} group={k.priceGroup} />
              </div>
            ) : (
              <div className="md:h-5" />
            )}
          </div>
        </div>
        <p
          className="border-t-4 pt-2 text-xs"
          style={{ borderColor: k.accentColor }}
        >
          {k.description}
        </p>
      </NavLink>
    );
  });
}

export default function KitchenList() {
  const data = useLoaderData<{ kitchens: Kitchen[] }>();
  return (
    <div>
      <BgImage
        src={t(routes.kitchens, "image")}
        className={twJoin(
          "relative",
          "grid aspect-[4/3] max-h-[40vh] place-items-center",
          "bg-gray-400 text-center text-xl font-bold text-white",
        )}
      >
        <div className="absolute inset-0 bg-black/40" />
        <div className="relative">
          <h2 className="font-semibold">Your imagination realised</h2>
          <h3 className="font-light">
            Thirteen kitchen ranges to suit any environment
          </h3>
        </div>
      </BgImage>
      <KitchenCompare />
      <div
        className={twJoin(
          "container my-20 grid gap-x-5 gap-y-10 md:grid-cols-6 lg:gap-x-10",
          "md:[&>a]:col-span-3",
          //"md:[&>:nth-child(4n-3)]:col-span-3",
          "md:[&>:nth-child(7)]:col-span-2",
          "md:[&>:nth-child(8)]:col-span-2",
          "md:[&>:nth-child(9)]:col-span-2",
        )}
      >
        <List kitchens={data.kitchens} />
      </div>
    </div>
  );
}
